/**
 * The job capacity as shown to admins; a capacity of 0 means unlimited.
 */
export function formatCapacity(capacity?: number) {
  return capacity === 0 ? '∞' : capacity
}
